import React, { useContext } from 'react';
import { observer } from 'mobx-react-lite';
import { HrFlexContainer, Separate } from '@components/styles/hr-styles';
import { ControllerEducation } from './education/controller';
import { ControllerPost } from './posts/controller';
import { ControllerLanguage } from './language/controller';
import { Curriculum } from './cv/files';
import { FilesMultiples } from './cv/file-multiple';
import { ControllerNetworks } from './networks/controller';
import { Questions } from './question/question';
import { Referral } from './referral/referral';
import { PersonalExpectations } from './personal-expectations/personal-expectations';
import { TermsConditions } from './terms-and-conditions/terms-and-conditions';
import { Legacy } from './legacy.js/legacy';
import useStore from '../store/useStore';
import { vacancyRequirementType } from '../../constant/vacancy-requirement';
import { DisplaySettingsContext } from '../store/display-settings';

export const StepEducationWorkExperience = observer(
  ({
    register,
    formState,
    control,
    getValues,
    setValue,
    unregister,
    setError,
    clearErrors,
    postulant,
    questions,
    vacancyRequirement,
    vacancy,
    show,
    action,
    trigger
  }) => {
    const { getDataPostulant } = useStore();
    const typePortal = getDataPostulant?.typePortal || 'external';
    const vacanciesBCRA = ['convocatoriabcra'];

    const { darkMode } = useContext(DisplaySettingsContext);

    return (
      <HrFlexContainer
        flexDirection='column'
        alignItems='flex-start'
        gap='32px'
        style={{ display: show ? '' : 'none' }}
      >
        {(vacancyRequirement.educ !== vacancyRequirementType.disabled ||
          vacancyRequirement.school !== vacancyRequirementType.disabled) && (
          <ControllerEducation
            vacancyRequirement={vacancyRequirement}
            register={register}
            formState={formState}
            control={control}
            postulant={postulant}
            setValue={setValue}
            getValues={getValues}
            unregister={unregister}
            action={action}
          />
        )}
        {vacancyRequirement.language !== vacancyRequirementType.disabled && (
          <ControllerLanguage
            vacancyRequirement={vacancyRequirement}
            formState={formState}
            control={control}
            postulant={postulant}
            getValues={getValues}
            setValue={setValue}
            unregister={unregister}
            vacancy={vacancy}
            action={action}
          />
        )}
        {vacancyRequirement.jobs !== vacancyRequirementType.disabled && (
          <ControllerPost
            vacancyRequirement={vacancyRequirement}
            register={register}
            formState={formState}
            control={control}
            postulant={postulant}
            setValue={setValue}
            getValues={getValues}
            unregister={unregister}
            action={action}
          />
        )}
        {vacancyRequirement.social_networks !== vacancyRequirementType.disabled && (
          <ControllerNetworks
            vacancyRequirement={vacancyRequirement}
            register={register}
            formState={formState}
            control={control}
            setValue={setValue}
            getValues={getValues}
            unregister={unregister}
            action={action}
            postulant={postulant}
          />
        )}
        {vacancyRequirement.attached_file !== vacancyRequirementType.disabled &&
          (vacanciesBCRA.includes(vacancy?.account) ? (
            <FilesMultiples
              vacancyRequirement={vacancyRequirement}
              register={register}
              formState={formState}
              control={control}
              postulant={postulant}
              setValue={setValue}
              getValues={getValues}
              setError={setError}
              clearErrors={clearErrors}
              vacancy={vacancy}
              action={action}
              trigger={trigger}
            />
          ) : (
            <Curriculum
              vacancyRequirement={vacancyRequirement}
              register={register}
              formState={formState}
              control={control}
              postulant={postulant}
              setValue={setValue}
              getValues={getValues}
              setError={setError}
              clearErrors={clearErrors}
              vacancy={vacancy}
              action={action}
              trigger={trigger}
            />
          ))}

        <Questions
          vacancyRequirement={vacancyRequirement}
          register={register}
          formState={formState}
          control={control}
          postulant={postulant}
          setValue={setValue}
          getValues={getValues}
          setError={setError}
          clearErrors={clearErrors}
          vacancy={vacancy}
          questions={questions}
          action={action}
        />

        <PersonalExpectations
          vacancyRequirement={vacancyRequirement}
          register={register}
          formState={formState}
          control={control}
          postulant={postulant}
          action={action}
          setValue={setValue}
        />
        {vacancyRequirement.known !== vacancyRequirementType.disabled && (
          <Referral
            vacancyRequirement={vacancyRequirement}
            register={register}
            formState={formState}
            control={control}
            postulant={postulant}
            setValue={setValue}
            getValues={getValues}
            setError={setError}
            clearErrors={clearErrors}
            vacancy={vacancy}
            unregister={unregister}
            action={action}
          />
        )}

        {typePortal === 'internal' && vacancyRequirement.legacy !== vacancyRequirementType.disabled && (
          <Legacy
            vacancyRequirement={vacancyRequirement}
            register={register}
            formState={formState}
            control={control}
            setValue={setValue}
            getValues={getValues}
          />
        )}

        {action !== 'edit' && (
          <>
            <Separate borderBottom={darkMode ? '1px solid #767676' : ''} />
            <TermsConditions formState={formState} control={control} />
          </>
        )}
      </HrFlexContainer>
    );
  }
);
